import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from 'react';
import { arrayOf, string, number, oneOfType, bool, func } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { Box, Dialog, Flex, Image, Embed } from '../../atoms';
import { Carousel } from '../../molecules';

const MediaCarousel = _ref => {
  let {
    alt,
    title,
    audio,
    images,
    video,
    imgWidth,
    imgHeight,
    imgMaxHeight,
    counterSeparator,
    showCounter,
    onImageChange,
    onImageClick,
    onAudioClick,
    onVideoClick,
    showMedia,
    lazy,
    preload
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["alt", "title", "audio", "images", "video", "imgWidth", "imgHeight", "imgMaxHeight", "counterSeparator", "showCounter", "onImageChange", "onImageClick", "onAudioClick", "onVideoClick", "showMedia", "lazy", "preload"]);

  const [imagesCounter, setCounter] = useState(1);
  const [dialogVisible, setDialogVisible] = useState();
  const mediaTypeHandler = {
    audio: onAudioClick,
    video: onVideoClick
  };
  const mediaTypeRender = {
    video: /*#__PURE__*/React.createElement(Embed, {
      "data-testid": "media-embed",
      src: video
    }),
    audio: /*#__PURE__*/React.createElement("audio", {
      "data-testid": "media-audio",
      controls: true,
      src: audio
    })
  };

  const toggleDialog = type => {
    const nextType = typeof type === 'string' && ['video', 'audio'].includes(type) ? type : null;
    setDialogVisible(nextType);
  };

  const handleMediaClick = type => {
    const mediaHandler = mediaTypeHandler[type];
    mediaHandler();
    toggleDialog(type);
  };

  const handleImageChange = index => {
    setCounter(index + 1);
    onImageChange(images[index]);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, _extends({
    "data-testid": "media-gallery",
    fontSize: 0,
    position: "relative"
  }, props), /*#__PURE__*/React.createElement(Carousel, {
    lazy: lazy,
    onChange: handleImageChange,
    showControls: false,
    auto: false
  }, images.map((image, index) => /*#__PURE__*/React.createElement(Box, {
    height: imgMaxHeight,
    key: `gallery-img-${index}`
  }, /*#__PURE__*/React.createElement(Image, {
    alt: alt,
    title: title,
    "data-testid": "media-gallery-image",
    key: `gallery-img-${index}`,
    src: image,
    m: "auto",
    width: imgWidth,
    height: imgHeight,
    maxHeight: imgMaxHeight,
    lazy: !preload || index !== 0,
    onClick: () => onImageClick(index)
  })))), showMedia && /*#__PURE__*/React.createElement(Flex, {
    "data-testid": "media-gallery-icons",
    position: "absolute",
    bottom: "16px",
    left: "16px",
    columnGap: 2
  }, !!video && /*#__PURE__*/React.createElement(Icon, {
    name: "VideoCircle",
    width: "40px",
    height: "40px",
    onClick: () => handleMediaClick('video'),
    "data-testid": "media-gallery-video-icon"
  }), !!audio && /*#__PURE__*/React.createElement(Icon, {
    name: "PodcastCircle",
    width: "40px",
    height: "40px",
    onClick: () => handleMediaClick('audio'),
    "data-testid": "media-gallery-audio-icon"
  })), showCounter && !!images.length && /*#__PURE__*/React.createElement(Box, {
    "data-testid": "media-gallery-counter",
    bg: "background.dark",
    color: "text.lightest",
    position: "absolute",
    bottom: "16px",
    right: "16px",
    paddingX: 2,
    paddingY: 1,
    borderRadius: "default",
    opacity: "85%"
  }, imagesCounter, counterSeparator, images.length)), dialogVisible && /*#__PURE__*/React.createElement(Dialog, {
    title: null,
    position: "center",
    showClose: true,
    onClickOutside: toggleDialog,
    visible: true
  }, mediaTypeRender[dialogVisible]));
};

process.env.NODE_ENV !== "production" ? MediaCarousel.propTypes = {
  images: arrayOf(string),
  audio: string,
  video: string,
  imgWidth: number,
  imgHeight: number,
  imgMaxHeight: oneOfType([number, string]),
  counterSeparator: string,
  showCounter: bool,
  alt: string,
  title: string,
  onImageChange: func,
  onImageClick: func,
  onVideoClick: func,
  onAudioClick: func,
  lazy: bool,
  preload: bool,
  showMedia: bool
} : void 0;
MediaCarousel.defaultProps = {
  audios: [],
  images: [],
  podcasts: [],
  videos: [],
  imgWidth: 800,
  imgHeight: 600,
  imgMaxHeight: '40vh',
  counterSeparator: ' de ',
  showCounter: true,
  alt: '',
  title: '',
  lazy: false,
  preload: false
};
export default MediaCarousel;